// extracted by mini-css-extract-plugin
export default {"badge":"BorBadge_badge__DkmFB","active":"BorBadge_active__EYgtI","resolved":"BorBadge_resolved__BmNNR","clickable":"BorBadge_clickable__VnSmF","side":"BorBadge_side__Jnxp0"};